function getDecimalHash (val) {
    let floor = Math.floor(val);
    let decimal = val - floor;
    let precision = 0;
  
    while ((decimal % 1) !== 0 && precision <= 8) {
      precision++;
      decimal *= 10;
    }
    decimal = Math.round(decimal);
  
    return getArrayHash([floor, decimal, precision]);
}
function getStringHash (val) {
    let hash = 0;
    for (let idx = 0, len = val.length; idx < len; idx++) {
      hash = ((hash << 5) - hash) + val.charCodeAt(idx);
    }
    return hash;
}
function getArrayHash (arr) {
    return arr.map(getItemHash).sort().reduce((hash, chash) => ((hash << 5) - hash) + chash, 0);
}
function getItemHash (val) {
    if (Array.isArray(val)) return getArrayHash(val);
    if (val && typeof val === 'object') {
      if (val instanceof Date) return val.getTime();
      if (typeof val.hashCode === 'function') return val.hashCode();
      if (typeof val.toJSON === 'function') return getItemHash(val.toJSON());
      return getArrayHash(Object.entries(val));
    }
    let isString = typeof val === 'string';
    if (isString && isNaN(val)) return getStringHash(val);
    if (isString && !isNaN(val) || typeof val === 'number') {
      let number = +val;
      return (number % 1 === 0) ? number : getDecimalHash(number);
    }
    if (typeof val === 'boolean') return val ? 1 : -1;
    return 0;
}

export default function calculate (...args) {
    if (args.length === 0) return;
    if (args.length === 1) return getItemHash(args[0]);
    return getArrayHash(args);
}
